<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle d-block">Jogo</span>
        <h3 class="page-title d-inline">Editar</h3>
        <router-link
          class="btn btn-success text-white float-right"
          :to="{ name: 'admin-puzzle-loop-new' }"
        >
          Novo jogo
        </router-link>
      </d-col>
    </d-row>
    <puzzle-loop-page />
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import PuzzleLoopPage from '../components/PuzzleLoopPage.vue';

export default {
  name: 'puzzle-loop-edit',
  components: {
    PuzzleLoopPage,
  },
  methods: {
    ...mapActions(['getPuzzleLoop']),
  },
  mounted() {
    if (this.$route.params.puzzleId) {
      this.getPuzzleLoop(this.$route.params.puzzleId);
    }
  },
};
</script>
